import {
  writable, readable

}
from 'svelte/store'

export const code = writable('Z1AG1');  export const zone_selected = writable('Z1');  
export const magnify_levels = readable([0.15, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75]);  
export const current_magnify_level = writable(2);  

export const map = readable([
  {
  name: 'Z1',
    title: '國安港安 家安民安',
    dimension: "width: 30%;  height: 30%;  ",
    position: "right: 12%;  top: 0%;  ",
    dimension_3D: " aspect-ratio: 1.3 / 1;width: 23%; rotate: 33deg;",
    position_3D: " right: 3%; top: 38%; ",
    shift: "translate(-30.5%, 35%)",
    shift_3D: "translate(-32%, -18%)",
    zone_scale: 1,
    pins: [
      {
  name: "AG1",
        position_3D: "top: 49.5%; left: 72%;",
        position: "top: 24.5%;  left: 88%",
        title: "----- Z1AG1 -----"
      
}
]
  
}
,
  {
  name: 'Z2',
    title: '祖國與香港', 
    dimension: "width: 45%;  height: 28%;  ",
    position: "left: 10%;  top: 0%;  ",
    dimension_3D: "aspect-ratio: 1.7 / 1; width: 25%; rotate: 33deg;",
    position_3D: "left: 51%;top: 15%; ",
    shift: "translate(16%, 35%)",
    shift_3D: "translate(-10%, 22%)",
    zone_scale: 0,
    pins: [
      {
      name: "AG3-4",
            position_3D: "top: 36.5%; left: 70%;",
            position: 'left: 46%;  top: 16%;  ',
            title: '----- Z2AG3-4 -----'
      
      }
,
      {
  name: "AG5",
        position_3D: "top: 29.5%; left: 70.5%;",
        position: 'left: 44%;  top: 9.5%;  ',
        title: '----- Z2AG5 -----'
      
}
,
      {
  name: "AG6",
        position_3D: "top: 22.5%; left: 68%;",
        position: 'left: 35%;  top: 6%;  ',
        title: '----- Z2AG6 -----',
      
}
,
      {
  name: "AG7",
        position_3D: "top: 18%; left: 64.5%;",
        position: 'left: 28%;  top: 4.5%;  ',
        title: '----- Z2AG7 -----',

}
,
      {
  name: "AG8",
        position_3D: "top: 15.1%; left: 60.55%;",
        position: 'left: 21.2%;  top: 6.2%;  ',
        title: '----- Z2AG8 -----',

}
,
      {
  name: "AG9-10",
        position_3D: "top: 24.3%; left: 53.7%;",
        position: 'left: 25.7%;  top: 23.3%;  ',
        title: '----- Z2AG9-10 -----',

}
,
      {
  name: "AG11-12",
        position_3D: "top: 22%; left: 54.5%;",
        position: 'left: 21.5%;  top: 18%;  ',
        title: '----- Z2AG11-12 -----'}
, {
  name: "AG13",
        position_3D: "top: 28%; left: 56%;",
        position: 'left: 33%;  top: 25.5%;  ',
        title: '----- Z2AG13 -----',

}
,
      {
  name: "AG14-15",
        position_3D: "top: 32.8%; left: 59.5%;",
        position: 'left: 38%;  top: 25.5%;  ',
        title: '----- Z2AG14-15 -----',}
,
      {
  name: "AG16",
        position_3D: "top: 42.8%; left: 67%;",
        position: 'left: 47%;  top: 25.5%;  ',
        title: '----- Z2AG16 -----',}
,
      {
  name: "AG17",
        position_3D: "top: 37.5%; left: 64.2%;",
        position: 'left: 41.5%;  top: 22.2%;  ',
        title: '----- Z2AG17 -----',}
,
      {
  name: "AG18",
        position_3D: "top: 44%; left: 69.5%;",
        position: 'left: 53%;  top: 24%;  ',
        title: '----- Z2AG18 -----',}
,
      {
  name: "AG19-20",
        position_3D: "top: 12%; left: 57.3%;",
        position: 'left: 16.2%;  top: 7%;  ',
        title: '----- Z2AG19-20 -----',}
,
      {
  name: "AG21",
        position_3D: "top: 11.5%; left: 54.2%;",
        position: 'left: 11.8%;  top: 10.5%;  ',
        title: '----- Z2AG21 -----',}
,
      {
  name: "AG22",
        position_3D: "top: 12.2%; left: 52.8%;",
        position: 'left: 11%;  top: 13.2%;  ',
        title: '----- Z2AG22 -----',}
,
      {
  name: "AG23",
        position_3D: "top: 18%; left: 51.3%;",
        position: 'left: 14.5%;  top: 18.5%;  ',
        title: '----- Z2AG23 -----',}
,{
  name: "AG24",
        position_3D: "top: 18%; left: 48.5%;",
        position: 'left: 14.5%;  top: 18.5%;  ',
        title: '----- Z2AG24 -----',}
,
      {
  name: "AG25",
        position_3D: "top: 21.2%; left: 48.2%;",
        position: 'left: 13.2%;  top: 24.2%;  ',
        title: '----- Z2AG25 -----'

}
]
  
}
,
  {
  name: 'Z3',
    title: '國安與你 息息相關',
    dimension: "width: 27%;  height: 32%;  ",
    position: "left: 0%;  top: 32%;  ",
    dimension_3D: " aspect-ratio: 1.5 / 1;height: 32%;rotate: -2deg;",
    position_3D: "left: 24%;  top: 18%;  ",
    shift: "translate(25%, 2.5%)",
    shift_3D: "translate(13%, 17.5%)",
    zone_scale: 0,
    pins: [
      {
  name: "AG26",
        position_3D: "top: 23.5%; left: 51%;",
        position: 'left: 19.5%;  top: 28%;  ',
        title: '----- Z3AG26 -----',}
,
      {
  name: "AG27",
        position_3D: "top: 27.5%; left: 46.8%;",
        position: 'left: 20.5%;  top: 34.5%;  ',
        title: '----- Z3AG27 no 28 -----',}
,
      {
  name: "AG29",
        position_3D: "top: 36.5%; left: 52.5%;",
        position: 'left: 30%;  top: 33.5%;  ',
        title: '----- Z3AG29 -----',}
,
      {
  name: "AG30",
        position_3D: "top: 44.2%; left: 58%;",
        position: 'left: 33.5%;  top: 33.5%;  ',
        title: '----- Z3AG30 -----',}
,
      {
  name: "AG31",
        position_3D: "top: 36.5%; left: 48.5%;",
        position: 'left: 27.5%;  top: 36%;  ',
        title: '----- Z3AG31 -----',}
,
      {
  name: "AG32",
        position_3D: "top: 46%; left: 46.4%;",
        position: 'left: 32%;  top: 46.5%;  ',
        title: '----- Z3AG32 -----',}
,
      {
  name: "AG33-34,37",
        position_3D: "top: 46.3%; left: 59.5%;",
        position: 'left: 45%;  top: 33.5%;  ',
        title: '----- Z3AG33-34,37 -----',}
,
      {
  name: "AG35-36",
        position_3D: "top: 48.2%; left: 58.2%;",
        position: 'left: 45%;  top: 37.5%;  ',
        title: '----- Z3AG35-36 -----',}
,
      {
  name: "AG38",
        position_3D: "top: 43%; left: 54.5%;",
        position: 'left: 38%;  top: 37.5%;  ',
        title: '----- Z3AG38 -----'}
,
      {
  name: "AG39",
        position_3D: "top: 45.7%; left: 56.4%;",
        position: 'left: 41.5%;  top: 37.5%;  ',
        title: '----- Z3AG39 -----'}
,
      {
  name: "AG40",
        position_3D: "top: 38%; left: 41.7%;",
        position: 'left: 22.5%;  top: 44.5%;  ',
        title: '----- Z3AG40 -----'}
,
      {
  name: "AG41-42",
        position_3D: "top: 37.5%; left: 46.5%;",
        position: 'left: 25.5%;  top: 41.5%;  ',
        title: '----- Z3AG42 -----'}
,
      {
  name: "AG43",
        position_3D: "top: 34%; left: 45%;",
        position: 'left: 20%;  top: 40%;  ',
        title: '----- Z3AG43 -----'}
,
      {
  name: "AG44",
        position_3D: "top: 27.7%; left: 43.2%;",
        position: 'left: 12.5%;  top: 34.5%;  ',
        title: '----- Z3AG44 -----'}
,
      {
  name: "AG45",
        position_3D: "top: 20.5%; left: 45.9%;",
        position: 'left: 10%;  top: 29.5%;  ',
        title: '----- Z3AG45 -----'}
,
      {
  name: "AG46",
        position_3D: "top: 18.5%; left: 39.8%;",
        position: 'left: 1.5%;  top: 34.5%;  ',
        title: '----- Z3AG46 -----'}
,
      {
  name: "AG47",
        position_3D: "top: 23%; left: 36.25%;",
        position: 'left: 1.5%;  top: 40%;  ',
        title: '----- Z3AG47 -----'}
,
      {
  name: "AG48",
        position_3D: "top: 25.5%; left: 34.3%;",
        position: 'left: 1.5%;  top: 43.5%;  ',
        title: '----- Z3AG48 -----'}
,
      {
  name: "AG49",
        position_3D: "top: 29.7%; left: 32.4%;",
        position: 'left: 3%;  top: 49.5%;  ',
        title: '----- Z3AG49 -----'}
,
      {
  name: "AG50",
        position_3D: "top: 33.8%; left: 29.1%;",
        position: 'left: 3%;  top: 54.5%;  ',
        title: '----- Z3AG50 -----'}
,
      {
  name: "AG51",
        position_3D: "top: 40.9%; left: 23.8%;",
        position: 'left: 3%;  top: 63.5%;  ',
        title: '----- Z3AG51 -----'}
,
      {
  name: "AG52",
        position_3D: "top: 42%; left: 30%;",
        position: 'left: 10%;  top: 59%;  ',
        title: '----- Z3AG52 -----'}
,
      {
  name: "AG53",
        position_3D: "top: 43.5%; left: 24.5%;",
        position: 'left: 7%;  top: 66%;  ',
        title: '----- Z3AG53 -----'}
,
      {
  name: "AG54",
        position_3D: "top: 48.5%; left: 28%;",
        position: 'left: 15%;  top: 66%;  ',
        title: '----- Z3AG54 -----'}
,
      {
  name: "AG55",
        position_3D: "top: 51.5%; left: 31.5%;",
        position: 'left: 22%;  top: 63%;  ',
        title: '----- Z3AG55 -----'}
,
      {
  name: "AG56",
        position_3D: "top: 47.8%; left: 37.7%;",
        position: 'left: 22%;  top: 57%;  ',
        title: '----- Z3AG56 -----'}
,
      {
  name: "AG57",
        position_3D: "top: 50%; left: 45.5%;",
        position: 'left: 35%;  top: 51.5%;  ',
        title: '----- Z3AG57 -----'}
] 
}
,
  {
  name: 'Z4',
    title: '國安立法 長治久安',
    dimension: "width: 10%;  height: 35%;  ",
    position: "left: 39%;  top: 41%;  ",
    dimension_3D: " height: 54%; rotate: 48deg; aspect-ratio: 1 / 4; ",
    position_3D: "left: 42%;  top: 39%;",
    shift: "translate(6%, -9%)",
    shift_3D: "translate(7%, -12%)",
    zone_scale: 0,
    pins: [
      {
  name: "AG58",
        position_3D: "top: 50%; left: 52.2%;",
        position: "top: 43%;  left: 39%",
        title: "----- Z4AG58 -----"}
,
      {
  name: "AG59",
        position_3D: "top: 52%; left: 53.9%;",
        position: "top: 43%;  left: 46.5%",
        title: "----- Z4AG59 -----"}
,
      {
  name: "AG60",
        position_3D: "top: 53.5%; left: 55%;",
        position: "top: 46%;  left: 45.5%",
        title: "----- Z4AG60 -----"}
,
      {
  name: "AG61",
        position_3D: "top: 61.7%; left: 49.5%;",
        position: "top: 54%;  left: 44.5%",
        title: "----- Z4AG61 -----"}
,
      {
  name: "AG62",
        position_3D: "top: 60.5%; left: 46.1%;",
        position: "top: 55%;  left: 39.5%",
        title: "----- Z4AG62 -----"}
,
      {
  name: "AG63",
        position_3D: "top: 69.5%; left: 44.5%;",
        position: "top: 62%;  left: 46.5%",
        title: "----- Z4AG63 -----"}
,
      {
  name: "AG64",
        position_3D: "top: 60.8%; left: 41%;",
        position: "top: 59.5%;  left: 36%",
        title: "----- Z4AG64,66 -----"}
,
      {
  name: "AG65",
        position_3D: "top: 76.5%; left: 35.5%;",
        position: "top: 73.5%;  left: 40.5%",
        title: "----- Z4AG65 -----"}
] 
}
,
  {
  name: 'Z5',
    title: '國家安全 繁榮穩定基石',
    dimension: "width: 15%;  height: 12%;  ",
    position: "left: 23%;  top: 68%;  ",
    dimension_3D: " height: 17%; aspect-ratio: 1 / 1; rotate: 54deg;",
    position_3D: "left: 25.5%;  top: 55%;  ",
    shift: "translate(19%, -24%)",
    shift_3D: "translate(18%, -16%)",
    zone_scale: 3,
    pins: [
      {
  name: "AG67-68",
        position_3D: "top: 64.5%; left: 35%;",
        position: "top: 66.5%;  left: 35.5%",
        title: "----- Z5AG67-68 -----"}
,
      {
  name: "AG69",
        position_3D: "top: 61.5%; left: 28.5%;",
        position: "top: 71%;  left: 24.5%",
        title: "----- Z5AG69 -----"}
,
      {
  name: "AG70",
        position_3D: "top: 71%; left: 30.5%;",
        position: "top: 75%;  left: 35.5%",
        title: "----- Z5AG70 -----"}
,
      {
  name: "AG71",
        position_3D: "top: 69%; left: 27.5%;",
        position: "top: 77.4%;  left: 30%",
        title: "----- Z5AG71 -----"}
]
  
}
,
  {
  name: 'Z6',
    title: '國安齊參與',
    dimension: "width: 21%;  height: 20%;  ",
    position: "left: 0%;  bottom: 1%;  ",
    dimension_3D: "width: 12%;  aspect-ratio: 1 / 1.6;    rotate: 46deg;",
    position_3D: "left: 8%;  bottom: 22%;  ",
    shift: "translate(37%, -30%)",
    shift_3D: "translate(34%, -10%)",
    zone_scale: 2,
    pins: [
      {
  name: "AG72",
        position_3D: "top: 63.5%; left: 21.2%;",
        position: "top: 79.5%;  left: 19%",
        title: "----- Z6AG72 -----"}
,
      {
  name: "AG73",
        position_3D: "top: 71%; left: 21%;",
        position: "top: 84%;  left: 22%",
        title: "----- Z6AG73 -----"}
,
      {
  name: "AG74",
        position_3D: "top: 67%; left: 17.5%;",
        position: "top: 85.5%;  left: 17%",
        title: "----- Z6AG74 -----"}
,
      {
  name: "AG75",
        position_3D: "top: 70%; left: 12.5%;",
        position: "top: 88.5%;  left: 14%",
        title: "----- Z6AG75 -----"}
,
      {
  name: "AG76",
        position_3D: "top: 58.3%; left: 13.7%;",
        position: "top: 84%;  left: 8%",
        title: "----- Z6AG76 -----"}
,
      {
  name: "AG77",
        position_3D: "top: 55%; left: 17.5%;",
        position: "top: 78%;  left: 11.5%",
        title: "----- Z6AG77 -----"}
,
      {
  name: "AG78",
        position_3D: "top: 50.5%; left: 22.5%;",
        position: "top: 71%;  left: 10%",
        title: "----- Z6AG77 -----"}
,
      {
  name: "AG79",
        position_3D: "top: 46.9%; left: 20.3%;",
        position: "top: 77%;  left: 3.5%",
        title: "----- Z6AG77 -----"}
]
  
}
])